import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { EntityCardSkeleton } from "./EntityCard";

interface EntityGridProps {
  children: ReactNode;
  columns?: 2 | 3 | 4;
  className?: string;
}

export function EntityGrid({ children, columns = 3, className }: EntityGridProps) {
  const columnClasses = {
    2: "md:grid-cols-2",
    3: "md:grid-cols-2 lg:grid-cols-3",
    4: "md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
  };

  return (
    <div className={cn("grid gap-6", columnClasses[columns], className)}>
      {children}
    </div>
  );
}

interface EntityGridSkeletonProps {
  count?: number;
  columns?: 2 | 3 | 4;
  aspectRatio?: "square" | "video" | "portrait";
}

export function EntityGridSkeleton({ 
  count = 6, 
  columns = 3,
  aspectRatio = "video" 
}: EntityGridSkeletonProps) {
  return (
    <EntityGrid columns={columns}>
      {Array.from({ length: count }).map((_, i) => (
        <EntityCardSkeleton key={i} aspectRatio={aspectRatio} />
      ))}
    </EntityGrid>
  );
}
